import React from "react";

const PodiumSection = ({ latestTournamentWithPodium, animatePodium }) => {
  if (!latestTournamentWithPodium) return null;

  const podiumStyle = (place) => {
    if (place === 1) return "bg-gradient-to-r from-yellow-500/20 to-yellow-600/10 border-yellow-500/40 text-yellow-300";
    if (place === 2) return "bg-gradient-to-r from-slate-400/15 to-slate-500/5 border-slate-400/30 text-slate-300";
    return "bg-gradient-to-r from-amber-700/15 to-amber-800/5 border-amber-700/30 text-amber-600";
  };

  return (
    <div
      className={`
        bg-gradient-to-br from-slate-800 via-slate-700 to-slate-800 border border-amber-500/20 rounded-lg shadow-lg p-4 text-slate-50
        transition-all duration-1000 ease-out transform
        ${animatePodium ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"}
      `}
    >
      <h3 className="text-center text-sm font-bold tracking-widest uppercase mb-1 text-amber-400">
        🏆 Derniers résultats
      </h3>
      <p className="text-center text-slate-400 text-xs mb-3">
        {latestTournamentWithPodium.type} —{" "}
        {new Date(latestTournamentWithPodium.date).toLocaleDateString("fr-FR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </p>
      <div className="space-y-4">
        {latestTournamentWithPodium.podiums.map((podium, index) => (
          <div key={index}>
            {podium.name && (
              <p className="font-semibold text-amber-400 text-xs mb-1.5 text-center">
                {podium.name}
              </p>
            )}
            <div className="space-y-1">
              {[
                { place: 1, icon: "🥇", name: podium.first },
                { place: 2, icon: "🥈", name: podium.second },
                { place: 3, icon: "🥉", name: podium.third },
              ].filter((p) => p.name).map((p) => (
                <div
                  key={p.place}
                  className={`flex items-center gap-2 px-3 py-1.5 rounded border ${podiumStyle(p.place)}`}
                >
                  <span className="text-lg flex-shrink-0">{p.icon}</span>
                  <span className="font-semibold text-sm break-words min-w-0">{p.name}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PodiumSection;
